import Controls from "../components/Controls";
import RoomHeader from "../components/RoomHeader";
import { useTranslation } from "../components/Localization";
import { getGameScore } from "../services/gameScores";

export default function ScorePage() {
  const { t } = useTranslation();
  const matchingScore = getGameScore("matching");
  const restorationScore = getGameScore("restorationOne") + getGameScore("restorationTwo");
  return (
    <main className="screen score">
      <RoomHeader roomId="dining" />
      <div className="score-copy">
        <strong>{t("common.completed")}</strong>
        <div>
          {Array.from({ length: 4 }, (_, index) => (
            <i key={index} />
          ))}
        </div>
        <span>4/4</span>
        <div className="room-score-results">
          <p>{t("score.matchingResult", { score: matchingScore, max: 15 })}</p>
          <p>{t("score.restorationResult", { score: restorationScore, max: 20 })}</p>
        </div>
      </div>
      <Controls backTo="/talalo/restauralas-2" nextTo="/tukorterem" />
    </main>
  );
}
